import template from './searchInput.html';
import './searchInput.scss';

const component = {
	bindings: {
		ngModel: '=',
		placeholder: '@'
	},
	template,
	controller: function($element, $timeout) {
		"ngInject"

		const vm = this;

		vm.clear = () => {
			vm.ngModel = undefined;
			$timeout(() => {
				$element.find('input')[0].focus();
			}, 0);
		}
		
		
	}
};

export default component;



// WEBPACK FOOTER //
// ./app/components/searchInput/searchInput.component.js